import { trpc } from "@blis/trpc/react";

import { Section } from "../components/Section";
import { UsersTable } from "../components/users/UsersTable";

export function UsersPage() {
  const { data } = trpc.admin.user.list.useQuery();
  return (
    <>
      <Section.Title>Users</Section.Title>
      <UsersTable users={data} />
    </>
  );
}
